package top.wcpe.allincore.layout.engine

/**
 * Flex 换行模式。
 *
 * 与 CSS / Taffy 一致：NOWRAP 表示主轴上不换行（子项被压缩或溢出）；WRAP 表示溢出时另起一行；
 * WRAP_REVERSE 表示换行方向反向（交叉轴反向堆叠）。
 */
enum class FlexWrap {
    NOWRAP,
    WRAP,
    WRAP_REVERSE
}
